import type {
  ApplicationLogger,
  LogDataType,
} from "./application-logger.types";

export abstract class ApplicationLoggerOutput implements ApplicationLogger {
  public log(..._params: LogDataType[]): void {}
  public error(
    _description: string,
    _location?: string,
    _error?: Error,
    _context?: LogDataType[],
  ): void {}
  public warn(..._params: LogDataType[]): void {}
  public info(..._params: LogDataType[]): void {}
  public debug(..._params: LogDataType[]): void {}
}
